import React, { useState } from 'react'

import Field from '../../Field/Field'
import FieldLabel from '../../FieldLabel/FieldLabel'
import Help from '../../Help/Help'
import InstructionText from '../../InstructionText/InstructionText'
import TextInput from '../../TextInput/TextInput'
import ToggleSwitch from '../../ToggleSwitch/ToggleSwitch'
import { fieldUidRegex, getContentTypeFieldDataTestId, CONTENT_TYPE_FIELD_ACTION_IDS } from '../helper'
import { booleanTestIdFormatter } from './../../../utils/helpers'

const ExperienceContainer = (props: any) => {
  const { onChange, uniqueKey, schema } = props

  const [initialSchema, setSchema] = useState(schema)
  const [error, setError] = useState(fieldUidRegex(schema.uid, schema))
  const { display_name, uid, field_metadata } = schema

  const onchange = () => {
    onChange && onChange(schema)
    setSchema({ ...schema })
  }

  const onDisplayNameChange = (event: any) => {
    schema.display_name = event.target.value

    if (schema.display_name && schema.newfield) {
      schema.uid = schema.display_name
        .trim()
        .replace(/[^A-Z0-9]+/gi, '_')
        .toLowerCase()
      schema.error_details = {
        ...schema.error_details,
        uid: ''
      }
    }

    if (!schema.error_details) {
      schema.error_details = {}
    }

    if (!schema.display_name.length) {
      schema.error = true
      schema.error_details = {
        ...schema.error_details,
        display_name: 'Display Name cannot be empty'
      }
    } else {
      schema.error = false
      schema.error_details = {
        ...schema.error_details,
        display_name: ''
      }
    }
    onchange()
  }
  const onUidChange = (event: any) => {
    setError(fieldUidRegex(event.target?.value?.trim(), schema))

    if (!schema.error_details) {
      schema.error_details = {}
    }

    if (!schema.uid.length) {
      schema.error = true
      schema.error_details = {
        ...schema.error_details,
        uid: 'uid cannot be empty'
      }
    } else {
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
      schema.error_details = {
        ...schema.error_details,
        uid: ''
      }
    }
    onchange()
  }
  const onInstructionChange = (event: any) => {
    field_metadata.instruction = event.target.value
    onchange()
  }
  const onHelpTextChange = (event: any) => {
    field_metadata.description = event.target.value
    onchange()
  }

  const onEnableDefaultVariationToggle = () => {
    field_metadata.enableDefaultVariation = !field_metadata.enableDefaultVariation
    onchange()
  }

  return (
    <>
      <div className="FormFields">
        <Field>
          <FieldLabel version='v2' testId='cs-ctf-experience-container-name' required htmlFor="displayName">
            {props.t('content_type.save_content_type.body.fields.experience_container.info_modal.display_name.label')}
          </FieldLabel>
          <TextInput
            version='v2'
            required
            autoFocus
            name={`${uniqueKey}.displayName`}
            value={display_name}
            onChange={onDisplayNameChange}
            error={schema.error && schema.error_details.display_name ? true : false}
            placeholder={props.t(
              'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
            )}
            testId={getContentTypeFieldDataTestId(schema, CONTENT_TYPE_FIELD_ACTION_IDS.DISPLAY_NAME_INPUT)}
          />
        </Field>
        <Field>
          <FieldLabel version='v2' testId='cs-ctf-experience-container-helptext-label' htmlFor="helpText">
            {props.t('content_type.save_content_type.body.fields.experience_container.info_modal.help_text.label')}
          </FieldLabel>
          <Help
            testId='cs-ctf-experience-container-helptext-helptext'
            type="basic"
            text={props.t(
              'content_type.save_content_type.body.fields.experience_container.info_modal.help_text.help_text'
            )}
          />
          <TextInput
            version='v2'
            name={`${uniqueKey}.helpText`}
            value={field_metadata.description || ''}
            onChange={onHelpTextChange}
            placeholder={props.t(
              'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
            )}
            testId={getContentTypeFieldDataTestId(schema, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}
          />
        </Field>
        <Field>
          <FieldLabel testId="cs-ctf-experience-container-uid-label" version='v2' required htmlFor="uid">
            {props.t('content_type.save_content_type.body.fields.experience_container.info_modal.uid.label')}
          </FieldLabel>
          <Help
            type="basic"
            testId="cs-ctf-experience-container-uid-helptext"
            text={props.t('content_type.save_content_type.body.fields.experience_container.info_modal.uid.help_text')}
          />
          <TextInput
            version='v2'
            required
            name={`${uniqueKey}.uid`}
            value={uid}
            onChange={onUidChange}
            error={(schema.error && schema.error_details.uid) || error ? true : false}
            placeholder={props.t(
              'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
            )}
            testId={getContentTypeFieldDataTestId(schema, CONTENT_TYPE_FIELD_ACTION_IDS.UID_INPUT)}
          />
        </Field>
        <Field>
          <FieldLabel testId="cs-ctf-experience-container-instruction-label" version='v2' htmlFor="instruction">
            {props.t(
              'content_type.save_content_type.body.fields.experience_container.info_modal.instruction_value.label'
            )}
          </FieldLabel>
          <Help
            type="basic"
            testId="cs-ctf-experience-container-instruction-helptext"
            text={props.t(
              'content_type.save_content_type.body.fields.experience_container.info_modal.instruction_value.help_text'
            )}
          />
          <TextInput
            version='v2'
            name={`${uniqueKey}.instruction`}
            value={field_metadata.placeholder || ''}
            onChange={onInstructionChange}
            placeholder={props.t(
              'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
            )}
            testId={getContentTypeFieldDataTestId(schema, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}
          />
        </Field>
      </div>
      <Field>
        <div className='ToggleWrap font-size-xl'>
          <ToggleSwitch
            name="enable-default-variation-toggle"
            checked={!!field_metadata.enableDefaultVariation}
            onChange={onEnableDefaultVariationToggle}
            label={props.t(
              'content_type.save_content_type.body.fields.experience_container.info_modal.default_variation.include_default_variation'
            )}
            testId={booleanTestIdFormatter(getContentTypeFieldDataTestId(schema, CONTENT_TYPE_FIELD_ACTION_IDS.DEFAULT_VARIATION_TOGGLE), !!field_metadata.enableDefaultVariation)}
          />
        </div>
      </Field>
      <InstructionText className='ml-16'>
        {props.t(
          'content_type.save_content_type.body.fields.experience_container.info_modal.default_variation.default_variation_instruction_text'
        )}
      </InstructionText>
    </>
  )
}

export default React.memo(ExperienceContainer)
